/* eslint-disable */
/* prettier-ignore */

/** An IntrospectionQuery representation of your schema.
 *
 * @remarks
 * This is an introspection of your schema saved as a file by GraphQLSP.
 * You may import it to create a `graphql()` tag function with `gql.tada`
 * by importing it and passing it to `initGraphQLTada<>()`.
 *
 * @example
 * ```
 * import { initGraphQLTada } from 'gql.tada';
 * import type { introspection } from './introspection';
 *
 * export const graphql = initGraphQLTada<{
 *   introspection: typeof introspection;
 *   scalars: {
 *     DateTime: string;
 *     Json: any;
 *   };
 * }>();
 * ```
 */
const introspection = {
  "__schema": {
    "queryType": {
      "name": "Query"
    },
    "mutationType": {
      "name": "Mutation"
    },
    "subscriptionType": null,
    "types": [
      {
        "kind": "OBJECT",
        "name": "AiChatCategoryView",
        "fields": [
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AiChatMessageCategory"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasNewMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "AiChatMessageCategory",
        "enumValues": [
          {
            "name": "ANNOUNCEMENT",
            "isDeprecated": false
          },
          {
            "name": "LEARNING_REPORT",
            "isDeprecated": false
          },
          {
            "name": "LEARNING_SUPPORT",
            "isDeprecated": false
          },
          {
            "name": "RESULT_REPORT",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AiChatMessageLastViewedUpdateInput",
        "inputFields": [
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AiChatMessageCategory"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "AiChatMessageLastViewedUpdatePayload",
        "fields": [
          {
            "name": "aiChatCategoryView",
            "type": {
              "kind": "OBJECT",
              "name": "AiChatCategoryView"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "AiChatMessageSelectAnswerOptionInput",
        "inputFields": [
          {
            "name": "aiSystemAnswerOptionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "guardianId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "AiChatMessageSelectAnswerOptionPayload",
        "fields": [
          {
            "name": "aiChatMessages",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "AiMessage"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "AiMessage",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AiMessageGuardian"
          },
          {
            "kind": "OBJECT",
            "name": "AiMessageSystem"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AiMessageConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "AiMessageEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "UNION",
                "name": "AiMessage"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AiMessageEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "UNION",
              "name": "AiMessage"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AiMessageGuardian",
        "fields": [
          {
            "name": "answerOption",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isSentGuardianMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "senderType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SenderType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "targetable",
            "type": {
              "kind": "UNION",
              "name": "AiMessageTargetable"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAiChatMessage"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AiMessageSystem",
        "fields": [
          {
            "name": "answerOptions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AiSystemAnswerOption"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "assets",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AiSystemChatAsset"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "imageUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isSentGuardianMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "link",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "linkText",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "messageType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AiSystemChatMessageType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "reacted",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "senderType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SenderType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "tag",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "targetable",
            "type": {
              "kind": "UNION",
              "name": "AiMessageTargetable"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseAiChatMessage"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "AiMessageTargetable",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "GuardianMessage"
          },
          {
            "kind": "OBJECT",
            "name": "LearningReport"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerEffort"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerTertiarySkillLevel"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AiSystemAnswerOption",
        "fields": [
          {
            "name": "answerOption",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AiSystemChatAsset",
        "fields": [
          {
            "name": "asset",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "updatedAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "AiSystemChatMessageType",
        "enumValues": [
          {
            "name": "ALREADY_REACTED",
            "isDeprecated": false
          },
          {
            "name": "CHALLENGE_CONTEST_REPORT_SHARE",
            "isDeprecated": false
          },
          {
            "name": "CHAT_ANNOUNCEMENT",
            "isDeprecated": false
          },
          {
            "name": "CURRICULUM_HEARING_COMPLETION",
            "isDeprecated": false
          },
          {
            "name": "DAILY_LEARNING_STARTED",
            "isDeprecated": false
          },
          {
            "name": "DAILY_REPORT_SHARE",
            "isDeprecated": false
          },
          {
            "name": "EXPL_LEARNING_REPORT_PUBLISH_SETTINGS",
            "isDeprecated": false
          },
          {
            "name": "EXPL_REPORT_SHARE",
            "isDeprecated": false
          },
          {
            "name": "FIRST_CURRICULUM_PLANNING_BY_AI",
            "isDeprecated": false
          },
          {
            "name": "FIRST_CURRICULUM_PLANNING_BY_HEARING",
            "isDeprecated": false
          },
          {
            "name": "FIRST_CURRICULUM_PLANNING_START",
            "isDeprecated": false
          },
          {
            "name": "GUARDIAN_SENT_MESSAGE",
            "isDeprecated": false
          },
          {
            "name": "KEEP_CURRENT_TERTIARY_SKILL_LEVEL",
            "isDeprecated": false
          },
          {
            "name": "LEARNING_SCHEDULE_SETTINGS_GUIDE",
            "isDeprecated": false
          },
          {
            "name": "MONTHLY_REPORT_SHARE",
            "isDeprecated": false
          },
          {
            "name": "PLAYER_EFFORT",
            "isDeprecated": false
          },
          {
            "name": "PLAYER_WORK_SHARE",
            "isDeprecated": false
          },
          {
            "name": "REMINDER_NOTIFICATION_AUTO_DISABLED",
            "isDeprecated": false
          },
          {
            "name": "SET_EXPL_LEARNING_REPORT_PUBLISH_SETTINGS_TO_PRIVATE",
            "isDeprecated": false
          },
          {
            "name": "SET_EXPL_LEARNING_REPORT_PUBLISH_SETTINGS_TO_PUBLIC",
            "isDeprecated": false
          },
          {
            "name": "SET_LOWER_TERTIARY_SKILL_LEVEL",
            "isDeprecated": false
          },
          {
            "name": "TERTIARY_SKILL_LEVEL_DOWN_NORMAL_REDOMMENDATION",
            "isDeprecated": false
          },
          {
            "name": "TERTIARY_SKILL_LEVEL_DOWN_STRONG_REDOMMENDATION",
            "isDeprecated": false
          },
          {
            "name": "WEEKLY_REPORT_SHARE",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AmountOffCoupon",
        "fields": [
          {
            "name": "amountOff",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "durationInMonths",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Coupon"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ApiError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AppVersionInfo",
        "fields": [
          {
            "name": "forceUpdate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AppVersions",
        "fields": [
          {
            "name": "android",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "androidInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AppVersionInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "ios",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "iosInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AppVersionInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentScore",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "score",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "scoreDifference",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AssessmentScoreHistory",
        "fields": [
          {
            "name": "bestScore",
            "type": {
              "kind": "OBJECT",
              "name": "ScoreHistory"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestScore",
            "type": {
              "kind": "OBJECT",
              "name": "AssessmentScore"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "previousScore",
            "type": {
              "kind": "OBJECT",
              "name": "ScoreHistory"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PrimarySkill"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "scoreHistories",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ScoreHistory"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "AuthenticationPayload",
        "fields": [
          {
            "name": "accessToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "fingerprint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "refreshToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "AvatarPartCategory",
        "enumValues": [
          {
            "name": "ACCESSORY",
            "isDeprecated": false
          },
          {
            "name": "BACKGROUND",
            "isDeprecated": false
          },
          {
            "name": "BACK_HAIR",
            "isDeprecated": false
          },
          {
            "name": "CLOTHES",
            "isDeprecated": false
          },
          {
            "name": "FACE",
            "isDeprecated": false
          },
          {
            "name": "FRONT_HAIR",
            "isDeprecated": false
          },
          {
            "name": "HAT",
            "isDeprecated": false
          },
          {
            "name": "TOP_HAIR",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "AvatarPartRewardItem",
        "fields": [
          {
            "name": "avatarPartId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "category",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "AvatarPartCategory"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "svg",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "RewardItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseAiChatMessage",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isSentGuardianMessage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "senderType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SenderType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "targetable",
            "type": {
              "kind": "UNION",
              "name": "AiMessageTargetable"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AiMessageGuardian"
          },
          {
            "kind": "OBJECT",
            "name": "AiMessageSystem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ApiError"
          },
          {
            "kind": "OBJECT",
            "name": "FileUploadNotFound"
          },
          {
            "kind": "OBJECT",
            "name": "GuardianTooManyError"
          },
          {
            "kind": "OBJECT",
            "name": "InvalidRequestError"
          },
          {
            "kind": "OBJECT",
            "name": "LimitExceededError"
          },
          {
            "kind": "OBJECT",
            "name": "MainSubscriptionIsNotActiveError"
          },
          {
            "kind": "OBJECT",
            "name": "OtherPlayerSubscriptionIsTrialing"
          },
          {
            "kind": "OBJECT",
            "name": "PasswordInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerSubscriptionIsNotCanceled"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerTooMany"
          },
          {
            "kind": "OBJECT",
            "name": "SubscriptionIsMainSubscriptionError"
          },
          {
            "kind": "OBJECT",
            "name": "TokenInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotHaveCurriculumLicenseError"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          },
          {
            "kind": "OBJECT",
            "name": "VerificationCodeInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "WrongEmailOrPassword"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BasePortfolioActivity",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PortfolioActivityVirtualKoov"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseSchoolContent",
        "fields": [
          {
            "name": "accessControl",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolContentAccessControl"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CurriculumSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "ExplSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "SubscriptionSchoolContent"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BaseUser",
        "fields": [
          {
            "name": "canDelete",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "challenges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Challenge"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "emailNotification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "fullName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "notSignedContracts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Contract"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolUsers",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchoolUser"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "userType",
            "type": {
              "kind": "ENUM",
              "name": "UserType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "SchoolUser"
          },
          {
            "kind": "OBJECT",
            "name": "User"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "Boolean"
      },
      {
        "kind": "OBJECT",
        "name": "CardPaymentMethod",
        "fields": [
          {
            "name": "brand",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "last4",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "PaymentMethod"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Challenge",
        "fields": [
          {
            "name": "countDownDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "entryAvailable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "entryEndAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "entryStartAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasChallengePlayers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playersConnection",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerConnection"
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "publishedNow",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "registrationAvailable",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "registrationEndAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "registrationStartAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "resultAt",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601DateTime"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ChallengeParticipateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ChallengeParticipateInput",
        "inputFields": [
          {
            "name": "challengeId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ChallengeParticipatePayload",
        "fields": [
          {
            "name": "challenge",
            "type": {
              "kind": "OBJECT",
              "name": "Challenge"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ChallengeParticipateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ChallengePlayerCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PlayerTooMany"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ChallengePlayerCreateInput",
        "inputFields": [
          {
            "name": "birthdateDay",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "birthdateMonth",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "birthdateYear",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "challengeId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "nickname",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ChallengePlayerCreatePayload",
        "fields": [
          {
            "name": "challenge",
            "type": {
              "kind": "OBJECT",
              "name": "Challenge"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ChallengePlayerCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ChallengePlayerParticipateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ChallengePlayerParticipateInput",
        "inputFields": [
          {
            "name": "challengeId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ChallengePlayerParticipatePayload",
        "fields": [
          {
            "name": "challenge",
            "type": {
              "kind": "OBJECT",
              "name": "Challenge"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ChallengePlayerParticipateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "ChallengeUserSignUpError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TokenInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ChallengeUserSignUpInput",
        "inputFields": [
          {
            "name": "challengeId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "emailNotification",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "defaultValue": "true"
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ChallengeUserSignUpPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "challenge",
            "type": {
              "kind": "OBJECT",
              "name": "Challenge"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "ChallengeUserSignUpError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CommentStampRewardItem",
        "fields": [
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "image",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "sizeType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "CommentStampSizeType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "RewardItem"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "CommentStampSizeType",
        "enumValues": [
          {
            "name": "LARGE",
            "isDeprecated": false
          },
          {
            "name": "SMALL",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Contest",
        "fields": [
          {
            "name": "challenge",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Challenge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "contestType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ContestType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "entryEndAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "entryStartAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "leaderBoard",
            "type": {
              "kind": "OBJECT",
              "name": "ContestAttemptLeaderBoard"
            },
            "args": [
              {
                "name": "grade",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ContestStatus"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContestAttempt",
        "fields": [
          {
            "name": "ageGroups",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "ContestAttemptAgeGroup"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "attemptAt",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601DateTime"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "contest",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Contest"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isFinished",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "organizations",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Organization"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "prefectures",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "JapanPrefecture"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "report",
            "type": {
              "kind": "OBJECT",
              "name": "ContestReport"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ContestAttemptAgeGroup",
        "enumValues": [
          {
            "name": "AGE_10S",
            "isDeprecated": false
          },
          {
            "name": "AGE_20S",
            "isDeprecated": false
          },
          {
            "name": "AGE_30S",
            "isDeprecated": false
          },
          {
            "name": "AGE_40S",
            "isDeprecated": false
          },
          {
            "name": "AGE_50S",
            "isDeprecated": false
          },
          {
            "name": "AGE_GTE_60",
            "isDeprecated": false
          },
          {
            "name": "AGE_LTE_10",
            "isDeprecated": false
          },
          {
            "name": "E1",
            "isDeprecated": false
          },
          {
            "name": "E2",
            "isDeprecated": false
          },
          {
            "name": "E3",
            "isDeprecated": false
          },
          {
            "name": "E4",
            "isDeprecated": false
          },
          {
            "name": "E5",
            "isDeprecated": false
          },
          {
            "name": "E6",
            "isDeprecated": false
          },
          {
            "name": "ELEMENTARY_SCHOOL",
            "isDeprecated": false
          },
          {
            "name": "GENERAL",
            "isDeprecated": false
          },
          {
            "name": "HIGH_SCHOOL",
            "isDeprecated": false
          },
          {
            "name": "J1",
            "isDeprecated": false
          },
          {
            "name": "J2",
            "isDeprecated": false
          },
          {
            "name": "J3",
            "isDeprecated": false
          },
          {
            "name": "JUNIOR_HIGH_SCHOOL",
            "isDeprecated": false
          },
          {
            "name": "P1",
            "isDeprecated": false
          },
          {
            "name": "P2",
            "isDeprecated": false
          },
          {
            "name": "P3",
            "isDeprecated": false
          },
          {
            "name": "PRESCHOOL",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContestAttemptConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContestAttemptEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContestAttempt"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestAttemptEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ContestAttempt"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ContestAttemptFilterInput",
        "inputFields": [
          {
            "name": "organizationId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "prefecture",
            "type": {
              "kind": "ENUM",
              "name": "JapanPrefecture"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ContestAttemptLeaderBoard",
        "fields": [
          {
            "name": "me",
            "type": {
              "kind": "OBJECT",
              "name": "ContestAttemptRanking"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "topTen",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ContestAttemptRanking"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestAttemptRanking",
        "fields": [
          {
            "name": "attempt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContestAttempt"
              }
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "grade",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerAge",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "point",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "position",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "publicPlayer",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PublicPlayer"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestPointStatistics",
        "fields": [
          {
            "name": "avgPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "histogram",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "HistogramBin"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "point",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "rank",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "standardScore",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestPrimarySkillPoint",
        "fields": [
          {
            "name": "point",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkill",
            "type": {
              "kind": "OBJECT",
              "name": "PrimarySkill"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestPrimarySkillPointStatistics",
        "fields": [
          {
            "name": "primarySkill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PrimarySkill"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "statistics",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContestPointStatistics"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestQuestionResult",
        "fields": [
          {
            "name": "answer",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "avgResponseDurationInSecond",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "correctRate",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isCorrect",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkill",
            "type": {
              "kind": "OBJECT",
              "name": "PrimarySkill"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "question",
            "type": {
              "kind": "OBJECT",
              "name": "Question"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "responseDurationHistogram",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "HistogramBin"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "responseDurationInSecond",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "skipRate",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ContestReport",
        "fields": [
          {
            "name": "advice",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "encouragingComment",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "generalComment",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "otherRecommendedJobs",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkillPoints",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ContestPrimarySkillPoint"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "questionResult",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "ContestQuestionResult"
                  }
                }
              }
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ContestAttemptFilterInput"
                }
              },
              {
                "name": "group",
                "type": {
                  "kind": "ENUM",
                  "name": "ContestAttemptAgeGroup"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "recommendedJob",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "recommendedJobDescription",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "recommendedJobSnap",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "speedPoint",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "statistics",
            "type": {
              "kind": "OBJECT",
              "name": "ContestStatistics"
            },
            "args": [
              {
                "name": "filter",
                "type": {
                  "kind": "INPUT_OBJECT",
                  "name": "ContestAttemptFilterInput"
                }
              },
              {
                "name": "group",
                "type": {
                  "kind": "ENUM",
                  "name": "ContestAttemptAgeGroup"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "ContestReportStatus"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thinkingCharacteristics",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thinkingLevel",
            "type": {
              "kind": "ENUM",
              "name": "ThinkingLevel"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalPoint",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ContestReportStatus",
        "enumValues": [
          {
            "name": "DONE",
            "isDeprecated": false
          },
          {
            "name": "INPROGRESS",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ContestStatistics",
        "fields": [
          {
            "name": "participantCount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkillPointStatistics",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ContestPrimarySkillPointStatistics"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "speedPointStatistics",
            "type": {
              "kind": "OBJECT",
              "name": "ContestPointStatistics"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalPointStatistics",
            "type": {
              "kind": "OBJECT",
              "name": "ContestPointStatistics"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ContestStatus",
        "enumValues": [
          {
            "name": "AWAITING_RESULT",
            "isDeprecated": false
          },
          {
            "name": "BEFORE_ENTRY",
            "isDeprecated": false
          },
          {
            "name": "ENTRY_AVAILABLE",
            "isDeprecated": false
          },
          {
            "name": "RESULT_AVAILABLE",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ContestType",
        "enumValues": [
          {
            "name": "PAST",
            "isDeprecated": false
          },
          {
            "name": "SAMPLE",
            "isDeprecated": false
          },
          {
            "name": "STANDARD",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Contract",
        "fields": [
          {
            "name": "content",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "contractType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ContractType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "signed",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "version",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ContractSignInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ContractSignPayload",
        "fields": [
          {
            "name": "contract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "contracts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Contract"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ContractType",
        "enumValues": [
          {
            "name": "COOKIE_REGULATION",
            "isDeprecated": false
          },
          {
            "name": "PRIVACY_POLICY",
            "isDeprecated": false
          },
          {
            "name": "TERM_OF_SALE",
            "isDeprecated": false
          },
          {
            "name": "TERM_OF_USAGE",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Coupon",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AmountOffCoupon"
          },
          {
            "kind": "OBJECT",
            "name": "GiftCoupon"
          },
          {
            "kind": "OBJECT",
            "name": "PercentOffCoupon"
          },
          {
            "kind": "OBJECT",
            "name": "TrialCoupon"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "CurrentUser",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "SchoolUser"
          },
          {
            "kind": "OBJECT",
            "name": "User"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Curriculum",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningStatusHeatmap",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LearningStatusHeatmap"
                }
              }
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkills",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PrimarySkill"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiency",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumLicense",
        "fields": [
          {
            "name": "curriculum",
            "type": {
              "kind": "OBJECT",
              "name": "Curriculum"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "CurriculumLicenseStatus"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumLicenseConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CurriculumLicenseEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CurriculumLicense"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumLicenseEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "CurriculumLicense"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "CurriculumLicenseStatus",
        "enumValues": [
          {
            "name": "EXPIRED",
            "isDeprecated": false
          },
          {
            "name": "IN_USE",
            "isDeprecated": false
          },
          {
            "name": "UNUSED",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumProficiency",
        "fields": [
          {
            "name": "curriculum",
            "type": {
              "kind": "OBJECT",
              "name": "Curriculum"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkill",
            "type": {
              "kind": "OBJECT",
              "name": "PrimarySkill"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumProficiencyHistory",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiency",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumProficiencyHistoryConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CurriculumProficiencyHistoryEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "CurriculumProficiencyHistory"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumProficiencyHistoryEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "CurriculumProficiencyHistory"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "CurriculumSchoolContent",
        "fields": [
          {
            "name": "accessControl",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolContentAccessControl"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseSchoolContent"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DailyLearningParameter",
        "fields": [
          {
            "name": "curriculumId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "dailyLearningFirst",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "detailedExplLearningSchedule",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "WeeklyLearningTimeSetting"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "detailedLearningSchedule",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "WeeklyLearningTimeSetting"
                }
              }
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "isLearningReminderEnabled",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningPolicy",
            "type": {
              "kind": "ENUM",
              "name": "LearningPolicyType"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningSchedule",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "WeekdayType"
                }
              }
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "learningScheduleKind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "LearningScheduleKind"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningScheduleWeeklies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "LearningScheduleWeekly"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkillParameters",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "DailyLearningPrimarySkillParameter"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "DailyLearningParameterUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DailyLearningParameterUpdateInput",
        "inputFields": [
          {
            "name": "dailyLearningFirst",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "detailedExplLearningSchedule",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WeeklyLearningTimeSettingInput"
                }
              }
            }
          },
          {
            "name": "detailedLearningSchedule",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "WeeklyLearningTimeSettingInput"
                }
              }
            }
          },
          {
            "name": "distributorId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "isLearningReminderEnabled",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "learningPolicy",
            "type": {
              "kind": "ENUM",
              "name": "LearningPolicyType"
            }
          },
          {
            "name": "learningSchedule",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "WeekdayType"
                }
              }
            }
          },
          {
            "name": "learningScheduleWeeklies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "LearningScheduleWeeklyInput"
                }
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "primarySkillParameters",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INPUT_OBJECT",
                  "name": "PrimarySkillParameterInput"
                }
              }
            }
          },
          {
            "name": "remindAt",
            "type": {
              "kind": "SCALAR",
              "name": "HourMinuteTime"
            }
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "DailyLearningParameterUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "DailyLearningParameterUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "DailyLearningPrimarySkillParameter",
        "fields": [
          {
            "name": "acquisitionEaseRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "currentLevelLearningRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nextLevelLearningRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "prevLevelLearningRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PrimarySkill"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "ratio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "DailyLearningStatus",
        "enumValues": [
          {
            "name": "ALL_COMPLETED",
            "isDeprecated": false
          },
          {
            "name": "DAILY_LEARNING_COMPLETED",
            "isDeprecated": false
          },
          {
            "name": "LESS_THAN_ALL_DAILY_LEARNING_COMPLETED",
            "isDeprecated": false
          },
          {
            "name": "LESS_THAN_HALF_DAILY_LEARNING_COMPLETED",
            "isDeprecated": false
          },
          {
            "name": "NONE",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DemoSubscriptionCreateInput",
        "inputFields": [
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "paymentMethodId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "subscriptionType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "DemoSubscriptionType"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "DemoSubscriptionCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "stripeClientSecret",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "DemoSubscriptionType",
        "enumValues": [
          {
            "name": "DEMO1",
            "isDeprecated": false
          },
          {
            "name": "DEMO2",
            "isDeprecated": false
          },
          {
            "name": "DEMO3",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "DirectUpload",
        "fields": [
          {
            "name": "headers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "JSON"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "httpMethod",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "uploadId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "DirectUploadCreateInput",
        "inputFields": [
          {
            "name": "byteSize",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "checksum",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "contentType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "filename",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "DirectUploadCreatePayload",
        "fields": [
          {
            "name": "directUpload",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "DirectUpload"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Distributor",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "planName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "EffortType",
        "enumValues": [
          {
            "name": "CONSECUTIVE_LEARNING_WEEKS",
            "isDeprecated": false
          },
          {
            "name": "PROGRAMMER_LEVEL",
            "isDeprecated": false
          },
          {
            "name": "TOTAL_COMPLETED_LEARNING_DAYS",
            "isDeprecated": false
          },
          {
            "name": "TOTAL_CORRECT_QUESTIONS",
            "isDeprecated": false
          },
          {
            "name": "TOTAL_REPORTS_AND_WORKS",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "EmailUpdateConfirmError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "VerificationCodeInvalid"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "EmailUpdateConfirmInput",
        "inputFields": [
          {
            "name": "verificationCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "EmailUpdateConfirmPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "EmailUpdateConfirmError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "EmailUpdateInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "EmailUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "EmptyPlayerCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PlayerTooMany"
          },
          {
            "kind": "OBJECT",
            "name": "UserDoesNotHaveCurriculumLicenseError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "EmptyPlayerCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "EmptyPlayerCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReport",
        "fields": [
          {
            "name": "canChangePublicationStatus",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explTitle",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "image",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "liked",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [
              {
                "name": "guardianId",
                "type": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "likesCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "publicationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExplPlayerReportPublicationStatus"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "reportData",
            "type": {
              "kind": "SCALAR",
              "name": "JSON"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "selectedImage",
            "type": {
              "kind": "OBJECT",
              "name": "GeneratedImage"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thumbnail",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReportConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExplPlayerReportEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExplPlayerReport"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExplPlayerReportDeleteInput",
        "inputFields": [
          {
            "name": "explPlayerReportId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReportDeletePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReport",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReport"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReportEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReport"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExplPlayerReportLikeInput",
        "inputFields": [
          {
            "name": "explPlayerReportId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "guardianId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReportLikePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReport",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReport"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "ExplPlayerReportPublicationStatus",
        "enumValues": [
          {
            "name": "FORCED_HIDE",
            "isDeprecated": false
          },
          {
            "name": "PENDING",
            "isDeprecated": false
          },
          {
            "name": "PRIVATE",
            "isDeprecated": false
          },
          {
            "name": "PUBLIC",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExplPlayerReportPublicationStatusUpdateInput",
        "inputFields": [
          {
            "name": "explPlayerReportId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "publicationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "ExplPlayerReportPublicationStatus"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReportPublicationStatusUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReport",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReport"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ExplPlayerReportUnlikeInput",
        "inputFields": [
          {
            "name": "explPlayerReportId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "guardianId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ExplPlayerReportUnlikePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReport",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReport"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ExplSchoolContent",
        "fields": [
          {
            "name": "accessControl",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolContentAccessControl"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseSchoolContent"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FcmTokenCreateInput",
        "inputFields": [
          {
            "name": "guardianId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "FcmTokenCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "FigureRewardItem",
        "fields": [
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "image",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "RewardItem"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "FileUploadNotFound",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "Float"
      },
      {
        "kind": "OBJECT",
        "name": "FormatValidation",
        "fields": [
          {
            "name": "format",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "FreeTrialSignUpError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "FreeTrialSignUpInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "FreeTrialSignUpPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "FreeTrialSignUpError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GeneratedImage",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "image",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thumbnail",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "GiftCoupon",
        "fields": [
          {
            "name": "gift",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Coupon"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Guardian",
        "fields": [
          {
            "name": "avatar",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nickname",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "players",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Player"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GuardianCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileUploadNotFound"
          },
          {
            "kind": "OBJECT",
            "name": "GuardianTooManyError"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GuardianCreateInput",
        "inputFields": [
          {
            "name": "avatarUploadId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "nickname",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "GuardianCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "GuardianCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "guardian",
            "type": {
              "kind": "OBJECT",
              "name": "Guardian"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GuardianDeleteInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "GuardianDeletePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "guardian",
            "type": {
              "kind": "OBJECT",
              "name": "Guardian"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GuardianMessage",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "GuardianMessageAiDraftCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ApiError"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GuardianMessageAiDraftCreateInput",
        "inputFields": [
          {
            "name": "aiOptionNoKanji",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "aiOptionPrefecture",
            "type": {
              "kind": "ENUM",
              "name": "JapanPrefecture"
            }
          },
          {
            "name": "aiOptionToneType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GuardianMessageAiOptionToneType"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "targetableId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "GuardianMessageAiDraftCreatePayload",
        "fields": [
          {
            "name": "draft",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "GuardianMessageAiDraftCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "GuardianMessageAiDraftStatus",
        "enumValues": [
          {
            "name": "EDITED",
            "isDeprecated": false
          },
          {
            "name": "UNUSED",
            "isDeprecated": false
          },
          {
            "name": "USED_AS_IS",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "GuardianMessageAiOptionToneType",
        "enumValues": [
          {
            "name": "CASUAL",
            "isDeprecated": false
          },
          {
            "name": "DIALECT",
            "isDeprecated": false
          },
          {
            "name": "POLITE",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GuardianMessageCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GuardianMessageCreateInput",
        "inputFields": [
          {
            "name": "aiDraftStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "GuardianMessageAiDraftStatus"
              }
            }
          },
          {
            "name": "aiOptionNoKanji",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "defaultValue": "false"
          },
          {
            "name": "aiOptionPrefecture",
            "type": {
              "kind": "ENUM",
              "name": "JapanPrefecture"
            }
          },
          {
            "name": "aiOptionToneType",
            "type": {
              "kind": "ENUM",
              "name": "GuardianMessageAiOptionToneType"
            }
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "targetableId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "GuardianMessageCreatePayload",
        "fields": [
          {
            "name": "aiChatMessage",
            "type": {
              "kind": "UNION",
              "name": "AiMessage"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "GuardianMessageCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GuardianSelectInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "GuardianSelectPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "guardian",
            "type": {
              "kind": "OBJECT",
              "name": "Guardian"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "GuardianTooManyError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "GuardianUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FileUploadNotFound"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "GuardianUpdateInput",
        "inputFields": [
          {
            "name": "avatarUploadId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "nickname",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "GuardianUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "GuardianUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "guardian",
            "type": {
              "kind": "OBJECT",
              "name": "Guardian"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "HistogramBin",
        "fields": [
          {
            "name": "count",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "lowerBound",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "upperBound",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "HourMinuteTime"
      },
      {
        "kind": "SCALAR",
        "name": "ID"
      },
      {
        "kind": "SCALAR",
        "name": "ISO8601Date"
      },
      {
        "kind": "SCALAR",
        "name": "ISO8601DateTime"
      },
      {
        "kind": "OBJECT",
        "name": "IapMonthlyPriceInfo",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "IapPricingInfo",
        "fields": [
          {
            "name": "monthly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IapMonthlyPriceInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "InAppPurchaseType",
        "enumValues": [
          {
            "name": "APPLE_STORE",
            "isDeprecated": false
          },
          {
            "name": "GOOGLE_PLAY",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InAppPurchaseValidateInput",
        "inputFields": [
          {
            "name": "inAppPurchaseType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "InAppPurchaseType"
              }
            }
          },
          {
            "name": "productId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "purchaseToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "InAppPurchaseValidatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "TokenInvalid"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "InitialPasswordSetupError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PasswordInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "TokenInvalid"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InitialPasswordSetupInput",
        "inputFields": [
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "InitialPasswordSetupPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "InitialPasswordSetupError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "Int"
      },
      {
        "kind": "OBJECT",
        "name": "InvalidRequestError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InvitationRedeemInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "verificationCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "InvitationRedeemPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "VerificationCodeInvalid"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "token",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "InviteInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "InvitePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ValidationError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Invoice",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "invoiceNo",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isFreeTrial",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "receiptUrl",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "InvoiceStatus"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "subscription",
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionInfo"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "total",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "InvoicePagination",
        "fields": [
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Invoice"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "paginationInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginationInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "InvoiceStatus",
        "enumValues": [
          {
            "name": "DRAFT",
            "isDeprecated": false
          },
          {
            "name": "OPEN",
            "isDeprecated": false
          },
          {
            "name": "PAID",
            "isDeprecated": false
          },
          {
            "name": "UNCOLLECTIBLE",
            "isDeprecated": false
          },
          {
            "name": "VOID",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "SCALAR",
        "name": "JSON"
      },
      {
        "kind": "ENUM",
        "name": "JapanPrefecture",
        "enumValues": [
          {
            "name": "AICHI",
            "isDeprecated": false
          },
          {
            "name": "AKITA",
            "isDeprecated": false
          },
          {
            "name": "AOMORI",
            "isDeprecated": false
          },
          {
            "name": "CHIBA",
            "isDeprecated": false
          },
          {
            "name": "EHIME",
            "isDeprecated": false
          },
          {
            "name": "FUKUI",
            "isDeprecated": false
          },
          {
            "name": "FUKUOKA",
            "isDeprecated": false
          },
          {
            "name": "FUKUSHIMA",
            "isDeprecated": false
          },
          {
            "name": "GIFU",
            "isDeprecated": false
          },
          {
            "name": "GUNMA",
            "isDeprecated": false
          },
          {
            "name": "HIROSHIMA",
            "isDeprecated": false
          },
          {
            "name": "HOKKAIDO",
            "isDeprecated": false
          },
          {
            "name": "HYOGO",
            "isDeprecated": false
          },
          {
            "name": "IBARAKI",
            "isDeprecated": false
          },
          {
            "name": "ISHIKAWA",
            "isDeprecated": false
          },
          {
            "name": "IWATE",
            "isDeprecated": false
          },
          {
            "name": "KAGAWA",
            "isDeprecated": false
          },
          {
            "name": "KAGOSHIMA",
            "isDeprecated": false
          },
          {
            "name": "KANAGAWA",
            "isDeprecated": false
          },
          {
            "name": "KOCHI",
            "isDeprecated": false
          },
          {
            "name": "KUMAMOTO",
            "isDeprecated": false
          },
          {
            "name": "KYOTO",
            "isDeprecated": false
          },
          {
            "name": "MIE",
            "isDeprecated": false
          },
          {
            "name": "MIYAGI",
            "isDeprecated": false
          },
          {
            "name": "MIYAZAKI",
            "isDeprecated": false
          },
          {
            "name": "NAGANO",
            "isDeprecated": false
          },
          {
            "name": "NAGASAKI",
            "isDeprecated": false
          },
          {
            "name": "NARA",
            "isDeprecated": false
          },
          {
            "name": "NIIGATA",
            "isDeprecated": false
          },
          {
            "name": "OITA",
            "isDeprecated": false
          },
          {
            "name": "OKAYAMA",
            "isDeprecated": false
          },
          {
            "name": "OKINAWA",
            "isDeprecated": false
          },
          {
            "name": "OSAKA",
            "isDeprecated": false
          },
          {
            "name": "SAGA",
            "isDeprecated": false
          },
          {
            "name": "SAITAMA",
            "isDeprecated": false
          },
          {
            "name": "SHIGA",
            "isDeprecated": false
          },
          {
            "name": "SHIMANE",
            "isDeprecated": false
          },
          {
            "name": "SHIZUOKA",
            "isDeprecated": false
          },
          {
            "name": "TOCHIGI",
            "isDeprecated": false
          },
          {
            "name": "TOKUSHIMA",
            "isDeprecated": false
          },
          {
            "name": "TOKYO",
            "isDeprecated": false
          },
          {
            "name": "TOTTORI",
            "isDeprecated": false
          },
          {
            "name": "TOYAMA",
            "isDeprecated": false
          },
          {
            "name": "WAKAYAMA",
            "isDeprecated": false
          },
          {
            "name": "YAMAGATA",
            "isDeprecated": false
          },
          {
            "name": "YAMAGUCHI",
            "isDeprecated": false
          },
          {
            "name": "YAMANASHI",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "LearningPolicyType",
        "enumValues": [
          {
            "name": "ACQUIRE_LEARNING_HABITS",
            "isDeprecated": false
          },
          {
            "name": "CHALLENGE_VARIOUS_THINGS",
            "isDeprecated": false
          },
          {
            "name": "CUSTOMIZE",
            "isDeprecated": false
          },
          {
            "name": "DELEGATE_TO_AI",
            "isDeprecated": false
          },
          {
            "name": "DELEGATE_TO_AI_BASED_ON_HEARING",
            "isDeprecated": false
          },
          {
            "name": "GROW_STRENGTH",
            "isDeprecated": false
          },
          {
            "name": "OVERCOME_WEAK_POINTS",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LearningReport",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "reportContent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "JSON"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "reportType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "LearningReportType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thumbnail",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "LearningReportType",
        "enumValues": [
          {
            "name": "CHALLENGE_CONTEST_REPORT",
            "isDeprecated": false
          },
          {
            "name": "CURRICULUM_DAILY_LEARNING",
            "isDeprecated": false
          },
          {
            "name": "DAILY_LEARNING",
            "isDeprecated": false
          },
          {
            "name": "EXPL_LEARNING",
            "isDeprecated": false
          },
          {
            "name": "INPROGRESS_DAILY_LEARNING",
            "isDeprecated": false
          },
          {
            "name": "MONTHLY_REPORT",
            "isDeprecated": false
          },
          {
            "name": "SCHOOL_CURRICULUM_DAILY_LEARNING",
            "isDeprecated": false
          },
          {
            "name": "SCRATCH_LEARNING",
            "isDeprecated": false
          },
          {
            "name": "VIRTUAL_KOOV_LEARNING",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "LearningScheduleKind",
        "enumValues": [
          {
            "name": "ALL_DAY",
            "isDeprecated": false
          },
          {
            "name": "SPECIFIC_DAY",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LearningScheduleWeekly",
        "fields": [
          {
            "name": "learningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "remindAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "HourMinuteTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "weekday",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WeekdayType"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LearningScheduleWeeklyInput",
        "inputFields": [
          {
            "name": "learningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "remindAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "HourMinuteTime"
              }
            }
          },
          {
            "name": "weekday",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WeekdayType"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "LearningStatusHeatmap",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "DailyLearningStatus"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LearningTimeData",
        "fields": [
          {
            "name": "differentLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalDay",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LearningTimeTransition",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "weekDay",
            "type": {
              "kind": "ENUM",
              "name": "WeekdayType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LearningTimeVisualization",
        "fields": [
          {
            "name": "dailyLearningTimeStats",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LearningTimeTransition"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningStatusHeatmap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LearningStatusHeatmap"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "monthlyLearningTimeStats",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LearningTimeTransition"
                  }
                }
              }
            },
            "args": [
              {
                "name": "startDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "thisMonthLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LearningTimeData"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thisWeekLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LearningTimeData"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LearningTimeData"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "weeklyLearningTimeStats",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "LearningTimeTransition"
                  }
                }
              }
            },
            "args": [
              {
                "name": "startDate",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              }
            ],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "LearningWork",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ExplPlayerReport"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerWork"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "LearningWorkConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "LearningWorkEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "UNION",
                "name": "LearningWork"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LearningWorkEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "UNION",
              "name": "LearningWork"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LengthValidation",
        "fields": [
          {
            "name": "max",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "min",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LevelShiftedSkillsPreviewInput",
        "inputFields": [
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "primarySkillId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "schoolGrade",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "schoolGradeLevel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "LevelShiftedSkillsPreviewPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "skillSteps",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SkillStep"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LevelShiftedSkillsUpdateInput",
        "inputFields": [
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "primarySkillId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "schoolGrade",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "schoolGradeLevel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "LevelShiftedSkillsUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "LicenseCodeActivateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LicenseCodeActivateInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "LicenseCodeActivatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "LicenseCodeActivateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "LicenseCodeCheckInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "LicenseCodeCheckPayload",
        "fields": [
          {
            "name": "product",
            "type": {
              "kind": "OBJECT",
              "name": "LicensedProduct"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LicensedProduct",
        "fields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "LimitExceededError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MainSubscriptionIsNotActiveError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "MonthlyPriceInfo",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "campaignAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "yearlyAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MotivationPointData",
        "fields": [
          {
            "name": "differentPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MotivationPointTransition",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "MotivationPointVisualization",
        "fields": [
          {
            "name": "currentPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "monthlyMotivationPointStats",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MotivationPointTransition"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thisMonthMotivationPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MotivationPointData"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thisWeekMotivationPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MotivationPointData"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalMotivationPoint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MotivationPointData"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "weeklyMotivationPointStats",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "MotivationPointTransition"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Mutation",
        "fields": [
          {
            "name": "aiChatMessageLastViewedUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "AiChatMessageLastViewedUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AiChatMessageLastViewedUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "aiChatMessageSelectAnswerOption",
            "type": {
              "kind": "OBJECT",
              "name": "AiChatMessageSelectAnswerOptionPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "AiChatMessageSelectAnswerOptionInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "challengeParticipate",
            "type": {
              "kind": "OBJECT",
              "name": "ChallengeParticipatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ChallengeParticipateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "challengePlayerCreate",
            "type": {
              "kind": "OBJECT",
              "name": "ChallengePlayerCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ChallengePlayerCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "challengePlayerParticipate",
            "type": {
              "kind": "OBJECT",
              "name": "ChallengePlayerParticipatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ChallengePlayerParticipateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "challengeUserSignUp",
            "type": {
              "kind": "OBJECT",
              "name": "ChallengeUserSignUpPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ChallengeUserSignUpInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "contractSign",
            "type": {
              "kind": "OBJECT",
              "name": "ContractSignPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ContractSignInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "dailyLearningParameterUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "DailyLearningParameterUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DailyLearningParameterUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "demoSubscriptionCreate",
            "type": {
              "kind": "OBJECT",
              "name": "DemoSubscriptionCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DemoSubscriptionCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "directUploadCreate",
            "type": {
              "kind": "OBJECT",
              "name": "DirectUploadCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "DirectUploadCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "emailUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "EmailUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "EmailUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "emailUpdateConfirm",
            "type": {
              "kind": "OBJECT",
              "name": "EmailUpdateConfirmPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "EmailUpdateConfirmInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "emptyPlayerCreate",
            "type": {
              "kind": "OBJECT",
              "name": "EmptyPlayerCreatePayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReportDelete",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReportDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExplPlayerReportDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReportLike",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReportLikePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExplPlayerReportLikeInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReportPublicationStatusUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReportPublicationStatusUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExplPlayerReportPublicationStatusUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReportUnlike",
            "type": {
              "kind": "OBJECT",
              "name": "ExplPlayerReportUnlikePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ExplPlayerReportUnlikeInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "fcmTokenCreate",
            "type": {
              "kind": "OBJECT",
              "name": "FcmTokenCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "FcmTokenCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "freeTrialSignUp",
            "type": {
              "kind": "OBJECT",
              "name": "FreeTrialSignUpPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "FreeTrialSignUpInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardianCreate",
            "type": {
              "kind": "OBJECT",
              "name": "GuardianCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GuardianCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardianDelete",
            "type": {
              "kind": "OBJECT",
              "name": "GuardianDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GuardianDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardianMessageAiDraftCreate",
            "type": {
              "kind": "OBJECT",
              "name": "GuardianMessageAiDraftCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GuardianMessageAiDraftCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardianMessageCreate",
            "type": {
              "kind": "OBJECT",
              "name": "GuardianMessageCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GuardianMessageCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardianSelect",
            "type": {
              "kind": "OBJECT",
              "name": "GuardianSelectPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GuardianSelectInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardianUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "GuardianUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "GuardianUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "inAppPurchaseValidate",
            "type": {
              "kind": "OBJECT",
              "name": "InAppPurchaseValidatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InAppPurchaseValidateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "initialPasswordSetup",
            "type": {
              "kind": "OBJECT",
              "name": "InitialPasswordSetupPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InitialPasswordSetupInput"
                  }
                }
              }
            ],
            "isDeprecated": true
          },
          {
            "name": "invitationRedeem",
            "type": {
              "kind": "OBJECT",
              "name": "InvitationRedeemPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InvitationRedeemInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "invite",
            "type": {
              "kind": "OBJECT",
              "name": "InvitePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "InviteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "levelShiftedSkillsPreview",
            "type": {
              "kind": "OBJECT",
              "name": "LevelShiftedSkillsPreviewPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LevelShiftedSkillsPreviewInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "levelShiftedSkillsUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "LevelShiftedSkillsUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LevelShiftedSkillsUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "licenseCodeActivate",
            "type": {
              "kind": "OBJECT",
              "name": "LicenseCodeActivatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LicenseCodeActivateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "licenseCodeCheck",
            "type": {
              "kind": "OBJECT",
              "name": "LicenseCodeCheckPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "LicenseCodeCheckInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "notificationPreferenceUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "NotificationPreferenceUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "NotificationPreferenceUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "passwordForgot",
            "type": {
              "kind": "OBJECT",
              "name": "PasswordForgotPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PasswordForgotInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "passwordForgotConfirm",
            "type": {
              "kind": "OBJECT",
              "name": "PasswordForgotConfirmPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PasswordForgotConfirmInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerDelete",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerHearingInformationUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerHearingInformationUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerHearingInformationUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerSubscriptionSwitch",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerSubscriptionSwitchPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerSubscriptionSwitchInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerValidate",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerValidatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerValidateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerWorkDelete",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWorkDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerWorkDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerWorkLike",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWorkLikePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerWorkLikeInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerWorkPublicationStatusUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWorkPublicationStatusUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerWorkPublicationStatusUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerWorkUnlike",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWorkUnlikePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PlayerWorkUnlikeInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "profileNameUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "ProfileNameUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ProfileNameUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "profilePasswordUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "ProfilePasswordUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ProfilePasswordUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "profileSetup",
            "type": {
              "kind": "OBJECT",
              "name": "ProfileSetupPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ProfileSetupInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "promotionCodeCheck",
            "type": {
              "kind": "OBJECT",
              "name": "PromotionCodeCheckPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "PromotionCodeCheckInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolCodeCheck",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolCodeCheckPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolCodeCheckInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolContentAccessControlUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolContentAccessControlUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolContentAccessControlUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGroupAssign",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroupAssignPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolGroupAssignInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGroupCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroupCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolGroupCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGroupDelete",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroupDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolGroupDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGroupUnassign",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroupUnassignPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolGroupUnassignInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGroupUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroupUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolGroupUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGuardianUserSignUp",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGuardianUserSignUpPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolGuardianUserSignUpInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentAsyncBatchCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentAsyncBatchCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentAsyncBatchCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentBatchCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentBatchCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentBatchCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentBind",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentBindPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentBindInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentDelete",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentPasswordReset",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentPasswordResetPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentPasswordResetInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolStudentUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolStudentUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolStudentUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolTeacherAsyncBatchCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolTeacherAsyncBatchCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolTeacherAsyncBatchCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolTeacherBatchCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolTeacherBatchCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolTeacherBatchCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolTeacherCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolTeacherCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolTeacherCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolTeacherDelete",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolTeacherDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolTeacherDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolTeacherPasswordReset",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolTeacherPasswordResetPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolTeacherPasswordResetInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolTeacherUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolTeacherUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolTeacherUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolUpdate",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUpdatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolUpdateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolUserCheck",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUserCheckPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolUserCheckInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolUserRegistrationConfirmFailure",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUserRegistrationConfirmFailurePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolUserRegistrationConfirmFailureInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolUserRegistrationConfirmSuccess",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUserRegistrationConfirmSuccessPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SchoolUserRegistrationConfirmSuccessInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "signIn",
            "type": {
              "kind": "OBJECT",
              "name": "SignInPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SignInInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "signInTokenCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SignInTokenCreatePayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "signOut",
            "type": {
              "kind": "OBJECT",
              "name": "SignOutPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SignOutInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "signUp",
            "type": {
              "kind": "OBJECT",
              "name": "SignUpPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SignUpInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "skillStepResetProficiencyRate",
            "type": {
              "kind": "OBJECT",
              "name": "SkillStepResetProficiencyRatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SkillStepResetProficiencyRateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "skillStepSetMastered",
            "type": {
              "kind": "OBJECT",
              "name": "SkillStepSetMasteredPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SkillStepSetMasteredInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripeDefaultPaymentMethodSetup",
            "type": {
              "kind": "OBJECT",
              "name": "StripeDefaultPaymentMethodSetupPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripeDefaultPaymentMethodSetupInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripeDefaultPaymentMethodSetupVerify",
            "type": {
              "kind": "OBJECT",
              "name": "StripeDefaultPaymentMethodSetupVerifyPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripeDefaultPaymentMethodSetupVerifyInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripePaymentIntentVerify",
            "type": {
              "kind": "OBJECT",
              "name": "StripePaymentIntentVerifyPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripePaymentIntentVerifyInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripeSubscriptionCancel",
            "type": {
              "kind": "OBJECT",
              "name": "StripeSubscriptionCancelPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripeSubscriptionCancelInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripeSubscriptionCreate",
            "type": {
              "kind": "OBJECT",
              "name": "StripeSubscriptionCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripeSubscriptionCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripeSubscriptionPrecreate",
            "type": {
              "kind": "OBJECT",
              "name": "StripeSubscriptionPrecreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripeSubscriptionPrecreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "stripeSubscriptionStopCancel",
            "type": {
              "kind": "OBJECT",
              "name": "StripeSubscriptionStopCancelPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "StripeSubscriptionStopCancelInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "surveyResponseCreate",
            "type": {
              "kind": "OBJECT",
              "name": "SurveyResponseCreatePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SurveyResponseCreateInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "tokenRefresh",
            "type": {
              "kind": "OBJECT",
              "name": "TokenRefreshPayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "TokenRefreshInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "tutorialComplete",
            "type": {
              "kind": "OBJECT",
              "name": "TutorialCompletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "TutorialCompleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "viewerDelete",
            "type": {
              "kind": "OBJECT",
              "name": "ViewerDeletePayload"
            },
            "args": [
              {
                "name": "input",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "ViewerDeleteInput"
                  }
                }
              }
            ],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AiMessageGuardian"
          },
          {
            "kind": "OBJECT",
            "name": "AiMessageSystem"
          },
          {
            "kind": "OBJECT",
            "name": "AiSystemAnswerOption"
          },
          {
            "kind": "OBJECT",
            "name": "AiSystemChatAsset"
          },
          {
            "kind": "OBJECT",
            "name": "Challenge"
          },
          {
            "kind": "OBJECT",
            "name": "Contest"
          },
          {
            "kind": "OBJECT",
            "name": "ContestAttempt"
          },
          {
            "kind": "OBJECT",
            "name": "ContestReport"
          },
          {
            "kind": "OBJECT",
            "name": "Curriculum"
          },
          {
            "kind": "OBJECT",
            "name": "CurriculumLicense"
          },
          {
            "kind": "OBJECT",
            "name": "CurriculumSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "Distributor"
          },
          {
            "kind": "OBJECT",
            "name": "ExplPlayerReport"
          },
          {
            "kind": "OBJECT",
            "name": "ExplSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "GeneratedImage"
          },
          {
            "kind": "OBJECT",
            "name": "Guardian"
          },
          {
            "kind": "OBJECT",
            "name": "Invoice"
          },
          {
            "kind": "OBJECT",
            "name": "Organization"
          },
          {
            "kind": "OBJECT",
            "name": "Player"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerWork"
          },
          {
            "kind": "OBJECT",
            "name": "PortfolioActivityVirtualKoov"
          },
          {
            "kind": "OBJECT",
            "name": "PrimarySkill"
          },
          {
            "kind": "OBJECT",
            "name": "School"
          },
          {
            "kind": "OBJECT",
            "name": "SchoolGroup"
          },
          {
            "kind": "OBJECT",
            "name": "SchoolUser"
          },
          {
            "kind": "OBJECT",
            "name": "SecondarySkill"
          },
          {
            "kind": "OBJECT",
            "name": "SkillStep"
          },
          {
            "kind": "OBJECT",
            "name": "SubscriptionInfo"
          },
          {
            "kind": "OBJECT",
            "name": "SubscriptionSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "Survey"
          },
          {
            "kind": "OBJECT",
            "name": "TertiarySkill"
          },
          {
            "kind": "OBJECT",
            "name": "User"
          },
          {
            "kind": "OBJECT",
            "name": "VirtualKoovLessonGroup"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "NotificationPreferenceUpdateInput",
        "inputFields": [
          {
            "name": "emailNotification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "NotificationPreferenceUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Organization",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "OtherPlayerSubscriptionIsTrialing",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PageInfo",
        "fields": [
          {
            "name": "endCursor",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasNextPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasPreviousPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "startCursor",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PaginationInfo",
        "fields": [
          {
            "name": "currentPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "perPage",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalPages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PasswordForgotConfirmError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "LimitExceededError"
          },
          {
            "kind": "OBJECT",
            "name": "VerificationCodeInvalid"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PasswordForgotConfirmInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "verificationCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PasswordForgotConfirmPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "PasswordForgotConfirmError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PasswordForgotInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PasswordForgotPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PasswordInvalid",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "PaymentMethod",
        "fields": [
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CardPaymentMethod"
          },
          {
            "kind": "OBJECT",
            "name": "UnknownPaymentMethod"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PercentOffCoupon",
        "fields": [
          {
            "name": "durationInMonths",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "percentOff",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Coupon"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Player",
        "fields": [
          {
            "name": "activeCurriculums",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Curriculum"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "age",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "aiChatCategoryViews",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "AiChatCategoryView"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "aiChatMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AiMessageConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "category",
                "type": {
                  "kind": "ENUM",
                  "name": "AiChatMessageCategory"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "assessmentScoreHistory",
            "type": {
              "kind": "OBJECT",
              "name": "AssessmentScoreHistory"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "availableCurriculums",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Curriculum"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "avatarId",
            "type": {
              "kind": "ENUM",
              "name": "PlayerAvatarId"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "birthdate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "birthdateDay",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "birthdateMonth",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canDelete",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "contestAttemptsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ContestAttemptConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "contestType",
                "type": {
                  "kind": "ENUM",
                  "name": "ContestType"
                }
              },
              {
                "name": "contestTypes",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "ENUM",
                      "name": "ContestType"
                    }
                  }
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "contestAttemptsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [
              {
                "name": "contestType",
                "type": {
                  "kind": "ENUM",
                  "name": "ContestType"
                }
              },
              {
                "name": "contestTypes",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "ENUM",
                      "name": "ContestType"
                    }
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "curriculumProficiencies",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "CurriculumProficiency"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "dailyLearningParameter",
            "type": {
              "kind": "OBJECT",
              "name": "DailyLearningParameter"
            },
            "args": [
              {
                "name": "distributorId",
                "type": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "distributors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Distributor"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explPlayerReportsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "ExplPlayerReportConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": true
          },
          {
            "name": "explPlayerReportsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "gamification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "guardianMessageLastAiOptionPrefecture",
            "type": {
              "kind": "ENUM",
              "name": "JapanPrefecture"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasActiveSubscription",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasSchoolCurriculum",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasSchoolExpl",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasSchoolSubscription",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hearingInformation",
            "type": {
              "kind": "SCALAR",
              "name": "JSON"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "invoicesPagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InvoicePagination"
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "1"
              },
              {
                "name": "perPage",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "25"
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "isActiveLogiqMember",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestTwoDaysAiChatMessages",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "UNION",
                    "name": "AiMessage"
                  }
                }
              }
            },
            "args": [
              {
                "name": "afterCursor",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              },
              {
                "name": "beforeCursor",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "learningTimeVisualization",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LearningTimeVisualization"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningWorksConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "LearningWorkConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "learningWorksCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "motivationPointVisualization",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MotivationPointVisualization"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nickname",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "orderUid",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "ownCurriculums",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Curriculum"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "planNames",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "planType",
            "type": {
              "kind": "ENUM",
              "name": "PlayerPlanType"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerAvatar",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerAvatar"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerLevel",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerPrimarySkillLevel"
            },
            "args": [
              {
                "name": "primarySkillId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerRewardItemsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerRewardItemConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "playerRewardItemsCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerType",
            "type": {
              "kind": "ENUM",
              "name": "PlayerType"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "portfolioActivities",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "PortfolioActivity"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkills",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PrimarySkill"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "safeName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGrade",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "studyStats",
            "type": {
              "kind": "OBJECT",
              "name": "StudyStats"
            },
            "args": [
              {
                "name": "afterCursor",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              },
              {
                "name": "beforeCursor",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              },
              {
                "name": "forCursor",
                "type": {
                  "kind": "SCALAR",
                  "name": "ISO8601Date"
                }
              },
              {
                "name": "frequency",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "StudyStatsFrequency"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "subscriptionInfo",
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionInfo"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PlayerAvatar",
        "fields": [
          {
            "name": "svg",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "PlayerAvatarId",
        "enumValues": [
          {
            "name": "BOY01",
            "isDeprecated": false
          },
          {
            "name": "BOY02",
            "isDeprecated": false
          },
          {
            "name": "GIRL01",
            "isDeprecated": false
          },
          {
            "name": "GIRL02",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PlayerConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "Player"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerDeleteInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerDeletePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ValidationError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerEffort",
        "fields": [
          {
            "name": "effortType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "EffortType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "effortValue",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isSpecial",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "programmerLevel",
            "type": {
              "kind": "OBJECT",
              "name": "ProgrammerLevel"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerHearingInformationUpdateInput",
        "inputFields": [
          {
            "name": "distributorId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "fromAiChat",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "defaultValue": "true"
          },
          {
            "name": "hearingInformation",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "JSON"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerHearingInformationUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ValidationError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "PlayerPlanType",
        "enumValues": [
          {
            "name": "LICENSE",
            "isDeprecated": false
          },
          {
            "name": "NO_PLAN",
            "isDeprecated": false
          },
          {
            "name": "SCHOOL_CURRICULUM",
            "isDeprecated": false
          },
          {
            "name": "SUBSCRIPTION",
            "isDeprecated": false
          },
          {
            "name": "SUBSCRIPTION_LICENSE",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PlayerPrimarySkillLevel",
        "fields": [
          {
            "name": "historiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerPrimarySkillLevelHistoryConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "level",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "levelDiff",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerTertiarySkillLevelsConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerTertiarySkillLevelConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "schoolGrade",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGradeLevel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerPrimarySkillLevelHistory",
        "fields": [
          {
            "name": "averageLevel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "medianLevel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerPrimarySkillLevelHistoryConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerPrimarySkillLevelHistoryEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerPrimarySkillLevelHistory"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerPrimarySkillLevelHistoryEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerPrimarySkillLevelHistory"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerRewardItem",
        "fields": [
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "rewardItem",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INTERFACE",
                "name": "RewardItem"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerRewardItemConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerRewardItemEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerRewardItem"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerRewardItemEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerRewardItem"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerSubscriptionIsNotCanceled",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerSubscriptionSwitchInput",
        "inputFields": [
          {
            "name": "otherPlayerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerSubscriptionSwitchPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "otherPlayer",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTertiarySkillLevel",
        "fields": [
          {
            "name": "historiesConnection",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerTertiarySkillLevelHistoryConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "level",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "levelDiff",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiencyRate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGrade",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGradeLevel",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "tertiarySkillId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTertiarySkillLevelConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerTertiarySkillLevelEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerTertiarySkillLevel"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTertiarySkillLevelEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerTertiarySkillLevel"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTertiarySkillLevelHistory",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "level",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTertiarySkillLevelHistoryConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerTertiarySkillLevelHistoryEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "PlayerTertiarySkillLevelHistory"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTertiarySkillLevelHistoryEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerTertiarySkillLevelHistory"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerTooMany",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "PlayerType",
        "enumValues": [
          {
            "name": "CHALLENGE_PLAYER",
            "isDeprecated": false
          },
          {
            "name": "GENERAL_PLAYER",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "PlayerUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerUpdateInput",
        "inputFields": [
          {
            "name": "gamification",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "PlayerUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PlayerValidateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerValidateInput",
        "inputFields": [
          {
            "name": "nickname",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerValidatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "PlayerValidateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "valid",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PlayerWork",
        "fields": [
          {
            "name": "canChangePublicationStatus",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canDelete",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "liked",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "likesCount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "publicationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PlayerWorkPublicationStatus"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "subtitle",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thumbnail",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "totalLearningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "work",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerWorkDeleteInput",
        "inputFields": [
          {
            "name": "playerWorkId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerWorkDeletePayload",
        "fields": [
          {
            "name": "deletedWorkId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerWorkLikeInput",
        "inputFields": [
          {
            "name": "playerWorkId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerWorkLikePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerWork",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWork"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "PlayerWorkPublicationStatus",
        "enumValues": [
          {
            "name": "FORCED_HIDE",
            "isDeprecated": false
          },
          {
            "name": "PENDING",
            "isDeprecated": false
          },
          {
            "name": "PRIVATE",
            "isDeprecated": false
          },
          {
            "name": "PUBLIC",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerWorkPublicationStatusUpdateInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "publicationStatus",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "PlayerWorkPublicationStatus"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerWorkPublicationStatusUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerWork",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWork"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PlayerWorkUnlikeInput",
        "inputFields": [
          {
            "name": "playerWorkId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PlayerWorkUnlikePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerWork",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerWork"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "PortfolioActivity",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "PortfolioActivityVirtualKoov"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PortfolioActivityVirtualKoov",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "learningTime",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "programmerLevel",
            "type": {
              "kind": "OBJECT",
              "name": "ProgrammerLevel"
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "virtualKoovContestTracks",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "VirtualKoovContestTrack"
                }
              }
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "virtualKoovLessonGroups",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "VirtualKoovLessonGroup"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "virtualKoovLessonTracks",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "VirtualKoovLessonTrack"
                }
              }
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BasePortfolioActivity"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "PricingInfo",
        "fields": [
          {
            "name": "campaignType",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isCampaignEnabled",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "monthly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "MonthlyPriceInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "yearly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "YearlyPriceInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PrimarySkill",
        "fields": [
          {
            "name": "curriculumProficiencyHistoriesConnection",
            "type": {
              "kind": "OBJECT",
              "name": "CurriculumProficiencyHistoryConnection"
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "curriculumId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiency",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [
              {
                "name": "curriculumId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              },
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "secondarySkills",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SecondarySkill"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "tertiarySkills",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TertiarySkill"
                  }
                }
              }
            },
            "args": [
              {
                "name": "curriculumId",
                "type": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PrimarySkillParameterInput",
        "inputFields": [
          {
            "name": "acquisitionEaseRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            }
          },
          {
            "name": "currentLevelLearningRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "nextLevelLearningRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            }
          },
          {
            "name": "prevLevelLearningRatio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            }
          },
          {
            "name": "ratio",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Float"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PrimarySkillStudyDuration",
        "fields": [
          {
            "name": "durationInSec",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "primarySkill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PrimarySkill"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProfileNameUpdateInput",
        "inputFields": [
          {
            "name": "emailNotification",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ProfileNameUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProfilePasswordUpdateInput",
        "inputFields": [
          {
            "name": "currentPassword",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "newPassword",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ProfilePasswordUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PasswordInvalid"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ProfileSetupInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "paymentType",
            "type": {
              "kind": "ENUM",
              "name": "UserPaymentType"
            },
            "defaultValue": "ORIGINAL_IN_WEB"
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ProfileSetupPayload",
        "fields": [
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "ProgrammerLevel",
        "fields": [
          {
            "name": "color",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "description",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "level",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "PromotionCodeCheckInput",
        "inputFields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "subscriptionType",
            "type": {
              "kind": "ENUM",
              "name": "SubscriptionType"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "PromotionCodeCheckPayload",
        "fields": [
          {
            "name": "coupon",
            "type": {
              "kind": "INTERFACE",
              "name": "Coupon"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "PublicPlayer",
        "fields": [
          {
            "name": "avatarId",
            "type": {
              "kind": "ENUM",
              "name": "PlayerAvatarId"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nickname",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerAvatar",
            "type": {
              "kind": "OBJECT",
              "name": "PlayerAvatar"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "playerType",
            "type": {
              "kind": "ENUM",
              "name": "PlayerType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Query",
        "fields": [
          {
            "name": "activeChallenges",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Challenge"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "challenge",
            "type": {
              "kind": "OBJECT",
              "name": "Challenge"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "currentGuardian",
            "type": {
              "kind": "OBJECT",
              "name": "Guardian"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "currentUser",
            "type": {
              "kind": "UNION",
              "name": "CurrentUser"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "iapPricingInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "IapPricingInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestAppVersions",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "AppVersions"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestContracts",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Contract"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestCookieRegulationContract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestTermOfSaleContract",
            "type": {
              "kind": "OBJECT",
              "name": "Contract"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "INTERFACE",
              "name": "Node"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "Node"
                }
              }
            },
            "args": [
              {
                "name": "ids",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "LIST",
                    "ofType": {
                      "kind": "NON_NULL",
                      "ofType": {
                        "kind": "SCALAR",
                        "name": "ID"
                      }
                    }
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "pricingInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PricingInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolPlayersList",
            "type": {
              "kind": "SCALAR",
              "name": "JSON"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolTeachersList",
            "type": {
              "kind": "SCALAR",
              "name": "JSON"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "stripeSubscriptionDefaultTrailEndInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "survey",
            "type": {
              "kind": "OBJECT",
              "name": "Survey"
            },
            "args": [
              {
                "name": "name",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": true
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "Question",
        "fields": [
          {
            "name": "answerExplanation",
            "type": {
              "kind": "OBJECT",
              "name": "QuestionAnswerExplanation"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "thumbnail",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "QuestionAnswerExplanation",
        "fields": [
          {
            "name": "asset",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "exText",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ResponseableInput",
        "inputFields": [
          {
            "name": "belongsToUser",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "challengeId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "contestAttemptId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "subscriptionId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "INTERFACE",
        "name": "RewardItem",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [],
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "AvatarPartRewardItem"
          },
          {
            "kind": "OBJECT",
            "name": "CommentStampRewardItem"
          },
          {
            "kind": "OBJECT",
            "name": "FigureRewardItem"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "School",
        "fields": [
          {
            "name": "code",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "contents",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolContentConnection"
              }
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "kind",
                "type": {
                  "kind": "ENUM",
                  "name": "SchoolContentKind"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "dailyLearningTitle",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "explLearningTitle",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "groups",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchoolGroup"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "groupsPagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolGroupPagination"
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "1"
              },
              {
                "name": "perPage",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "25"
              },
              {
                "name": "searchText",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestSchoolUserRegistrationRequest",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUserRegistrationRequest"
            },
            "args": [
              {
                "name": "userType",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "ENUM",
                    "name": "SchoolUserRegistrationRequestUserType"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "loginName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "qrcodeExpirationPeriodInDays",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "studentsPagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolUserPagination"
              }
            },
            "args": [
              {
                "name": "includeInactive",
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean"
                }
              },
              {
                "name": "page",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "1"
              },
              {
                "name": "perPage",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "25"
              },
              {
                "name": "schoolGroupIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "ID"
                    }
                  }
                }
              },
              {
                "name": "searchText",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "teachersPagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolUserPagination"
              }
            },
            "args": [
              {
                "name": "includeInactive",
                "type": {
                  "kind": "SCALAR",
                  "name": "Boolean"
                }
              },
              {
                "name": "page",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "1"
              },
              {
                "name": "perPage",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "25"
              },
              {
                "name": "schoolGroupIds",
                "type": {
                  "kind": "LIST",
                  "ofType": {
                    "kind": "NON_NULL",
                    "ofType": {
                      "kind": "SCALAR",
                      "name": "ID"
                    }
                  }
                }
              },
              {
                "name": "searchText",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "verificationFields",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "VerificationField"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "verificationFieldsOptions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "VerificationField"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolCodeCheckInput",
        "inputFields": [
          {
            "name": "schoolCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolCodeCheckPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "valid",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolContent",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "CurriculumSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "ExplSchoolContent"
          },
          {
            "kind": "OBJECT",
            "name": "SubscriptionSchoolContent"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SchoolContentAccessControl",
        "fields": [
          {
            "name": "groups",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchoolGroup"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SchoolContentAccessControlKind"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolContentAccessControlInput",
        "inputFields": [
          {
            "name": "groupIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            }
          },
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SchoolContentAccessControlKind"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "ENUM",
        "name": "SchoolContentAccessControlKind",
        "enumValues": [
          {
            "name": "ALL",
            "isDeprecated": false
          },
          {
            "name": "GROUPS",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolContentAccessControlUpdateInput",
        "inputFields": [
          {
            "name": "accessControl",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "SchoolContentAccessControlInput"
              }
            }
          },
          {
            "name": "schoolContentId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolContentAccessControlUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolContent",
            "type": {
              "kind": "UNION",
              "name": "SchoolContent"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolContentConnection",
        "fields": [
          {
            "name": "edges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolContentEdge"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nodes",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "UNION",
                "name": "SchoolContent"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "pageInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PageInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolContentEdge",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "node",
            "type": {
              "kind": "UNION",
              "name": "SchoolContent"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "SchoolContentKind",
        "enumValues": [
          {
            "name": "CURRICULUM",
            "isDeprecated": false
          },
          {
            "name": "EXPL",
            "isDeprecated": false
          },
          {
            "name": "SUBSCRIPTION",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroup",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolUsersPagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SchoolUserPagination"
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "1"
              },
              {
                "name": "perPage",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "25"
              }
            ],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolGroupAssignInput",
        "inputFields": [
          {
            "name": "schoolGroupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "schoolUserIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroupAssignPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGroup",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroup"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolGroupCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolGroupCreateInput",
        "inputFields": [
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroupCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolGroupCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGroup",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroup"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolGroupDeleteError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolGroupDeleteInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroupDeletePayload",
        "fields": [
          {
            "name": "deletedSchoolGroupId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolGroupDeleteError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroupPagination",
        "fields": [
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SchoolGroup"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "paginationInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginationInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolGroupUnassignInput",
        "inputFields": [
          {
            "name": "schoolGroupId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "schoolUserIds",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroupUnassignPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGroup",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroup"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolGroupUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolGroupUpdateInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGroupUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolGroupUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolGroup",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolGroup"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolGuardianUserSignUpError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ApiError"
          },
          {
            "kind": "OBJECT",
            "name": "TokenInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolGuardianUserSignUpInput",
        "inputFields": [
          {
            "name": "emailNotification",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "defaultValue": "true"
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "schoolCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "verification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "SchoolStudentBindVerification"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolGuardianUserSignUpPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolGuardianUserSignUpError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "SchoolRole",
        "enumValues": [
          {
            "name": "ADMIN",
            "isDeprecated": false
          },
          {
            "name": "STUDENT",
            "isDeprecated": false
          },
          {
            "name": "TEACHER",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SchoolStudentAsyncBatchCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentAsyncBatchCreateInput",
        "inputFields": [
          {
            "name": "allowUpdate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "fileId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentAsyncBatchCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolStudentAsyncBatchCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolStudentBatchCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentBatchCreateInput",
        "inputFields": [
          {
            "name": "allowUpdate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "fileId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentBatchCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolStudentBatchCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "loginData",
            "type": {
              "kind": "SCALAR",
              "name": "JSON"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolStudentBindError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentBindInput",
        "inputFields": [
          {
            "name": "schoolCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "verification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "SchoolStudentBindVerification"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentBindPayload",
        "fields": [
          {
            "name": "currentUser",
            "type": {
              "kind": "UNION",
              "name": "CurrentUser"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolStudentBindError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolUser",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentBindVerification",
        "inputFields": [
          {
            "name": "birthdate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            }
          },
          {
            "name": "memberId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "UNION",
        "name": "SchoolStudentCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentCreateInput",
        "inputFields": [
          {
            "name": "active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "birthdate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "groupIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "memberId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "nickname",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentCreatePayload",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolStudentCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "password",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "student",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentDeleteInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentDeletePayload",
        "fields": [
          {
            "name": "deletedStudentId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentPasswordResetInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentPasswordResetPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PasswordInvalid"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "password",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "student",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolStudentUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolStudentUpdateInput",
        "inputFields": [
          {
            "name": "active",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "birthdate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "groupIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "memberId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "nickname",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolStudentUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolStudentUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "student",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolTeacherAsyncBatchCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolTeacherAsyncBatchCreateInput",
        "inputFields": [
          {
            "name": "allowUpdate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "fileId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolTeacherAsyncBatchCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolTeacherAsyncBatchCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolTeacherBatchCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolTeacherBatchCreateInput",
        "inputFields": [
          {
            "name": "allowUpdate",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "fileId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolTeacherBatchCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolTeacherBatchCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "loginData",
            "type": {
              "kind": "SCALAR",
              "name": "JSON"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolTeacherCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolTeacherCreateInput",
        "inputFields": [
          {
            "name": "active",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            }
          },
          {
            "name": "birthdate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "groupIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "memberId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolTeacherCreatePayload",
        "fields": [
          {
            "name": "email",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolTeacherCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "password",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "teacher",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolTeacherDeleteInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolTeacherDeletePayload",
        "fields": [
          {
            "name": "deletedTeacherId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolTeacherPasswordResetInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolTeacherPasswordResetPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "PasswordInvalid"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "password",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "teacher",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolTeacherUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolTeacherUpdateInput",
        "inputFields": [
          {
            "name": "active",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            }
          },
          {
            "name": "birthdate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            }
          },
          {
            "name": "firstName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "groupIds",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "SCALAR",
                  "name": "ID"
                }
              }
            }
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "memberId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "nickname",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolTeacherUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolTeacherUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "teacher",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolUser"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SchoolUpdateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolUpdateInput",
        "inputFields": [
          {
            "name": "name",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "qrcodeExpirationPeriodInDays",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            }
          },
          {
            "name": "verificationFields",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "ENUM",
                  "name": "VerificationField"
                }
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUpdatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolUpdateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUser",
        "fields": [
          {
            "name": "active",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canDelete",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "challenges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Challenge"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "emailNotification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "fullName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "groups",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchoolGroup"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "memberId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "notSignedContracts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Contract"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "role",
            "type": {
              "kind": "ENUM",
              "name": "SchoolRole"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolUsers",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchoolUser"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "userType",
            "type": {
              "kind": "ENUM",
              "name": "UserType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseUser"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SchoolUserCheckError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolUserCheckInput",
        "inputFields": [
          {
            "name": "schoolCode",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "verification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "SchoolStudentBindVerification"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUserCheckPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SchoolUserCheckError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "valid",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUserPagination",
        "fields": [
          {
            "name": "nodes",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SchoolUser"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "paginationInfo",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "PaginationInfo"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolUserRegistrationConfirmFailureInput",
        "inputFields": [
          {
            "name": "requestId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUserRegistrationConfirmFailurePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SchoolUserRegistrationConfirmSuccessInput",
        "inputFields": [
          {
            "name": "requestId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUserRegistrationConfirmSuccessPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "school",
            "type": {
              "kind": "OBJECT",
              "name": "School"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SchoolUserRegistrationRequest",
        "fields": [
          {
            "name": "completedAt",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601DateTime"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "createdAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601DateTime"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "excel",
            "type": {
              "kind": "OBJECT",
              "name": "UploadedFile"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "expiredAt",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601DateTime"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "SchoolUserRegistrationRequestStatus"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "userType",
            "type": {
              "kind": "ENUM",
              "name": "SchoolUserRegistrationRequestUserType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "SchoolUserRegistrationRequestStatus",
        "enumValues": [
          {
            "name": "CONFIRMED_FAILURE",
            "isDeprecated": false
          },
          {
            "name": "CONFIRMED_SUCCESS",
            "isDeprecated": false
          },
          {
            "name": "EXPIRED",
            "isDeprecated": false
          },
          {
            "name": "FAILED",
            "isDeprecated": false
          },
          {
            "name": "INPROGRESS",
            "isDeprecated": false
          },
          {
            "name": "SUCCEEDED",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SchoolUserRegistrationRequestUserType",
        "enumValues": [
          {
            "name": "STUDENT",
            "isDeprecated": false
          },
          {
            "name": "TEACHER",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ScoreHistory",
        "fields": [
          {
            "name": "date",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "score",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SecondarySkill",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "tertiarySkills",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "TertiarySkill"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SenderType",
        "enumValues": [
          {
            "name": "AI_SYSTEM",
            "isDeprecated": false
          },
          {
            "name": "GUARDIAN",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SignInInput",
        "inputFields": [
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SignInPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "WrongEmailOrPassword"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SignInTokenCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SignInTokenCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SignInTokenCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "token",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SignOutInput",
        "inputFields": [
          {
            "name": "fcmToken",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "refreshToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SignOutPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ValidationError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "SignUpError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "TokenInvalid"
          },
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SignUpInput",
        "inputFields": [
          {
            "name": "emailNotification",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "defaultValue": "true"
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "password",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "token",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SignUpPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SignUpError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SkillStep",
        "fields": [
          {
            "name": "explanation",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "level",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiency",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "uid",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SkillStepResetProficiencyRateInput",
        "inputFields": [
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "skillStepId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SkillStepResetProficiencyRatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Player"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "skillStep",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SkillStep"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "tertiarySkill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TertiarySkill"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SkillStepSetMasteredInput",
        "inputFields": [
          {
            "name": "playerId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "skillStepId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SkillStepSetMasteredPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "Player"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "skillStep",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "SkillStep"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "tertiarySkill",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "TertiarySkill"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "SCALAR",
        "name": "String"
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripeDefaultPaymentMethodSetupInput",
        "inputFields": [
          {
            "name": "paymentMethodId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripeDefaultPaymentMethodSetupPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "stripeSetupClientSecret",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripeDefaultPaymentMethodSetupVerifyInput",
        "inputFields": [
          {
            "name": "stripeSetupClientSecret",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "stripeSetupIntent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripeDefaultPaymentMethodSetupVerifyPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripePaymentIntentVerifyInput",
        "inputFields": [
          {
            "name": "stripePaymentClientSecret",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "stripePaymentIntent",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripePaymentIntentVerifyPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "StripeSubscriptionCancelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "SubscriptionIsMainSubscriptionError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripeSubscriptionCancelInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripeSubscriptionCancelPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "StripeSubscriptionCancelError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "subscriptionInfo",
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionInfo"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "StripeSubscriptionCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InvalidRequestError"
          },
          {
            "kind": "OBJECT",
            "name": "OtherPlayerSubscriptionIsTrialing"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerSubscriptionIsNotCanceled"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerTooMany"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripeSubscriptionCreateInput",
        "inputFields": [
          {
            "name": "paymentMethodId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "playerId",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "promotionCode",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "subscriptionType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SubscriptionType"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripeSubscriptionCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "StripeSubscriptionCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "player",
            "type": {
              "kind": "OBJECT",
              "name": "Player"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "stripeClientSecret",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "stripeSetupClientSecret",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "StripeSubscriptionPrecreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "InvalidRequestError"
          },
          {
            "kind": "OBJECT",
            "name": "OtherPlayerSubscriptionIsTrialing"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerSubscriptionIsNotCanceled"
          },
          {
            "kind": "OBJECT",
            "name": "PlayerTooMany"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripeSubscriptionPrecreateInput",
        "inputFields": [
          {
            "name": "playerId",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "promotionCode",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          },
          {
            "name": "subscriptionType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SubscriptionType"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripeSubscriptionPrecreatePayload",
        "fields": [
          {
            "name": "coupon",
            "type": {
              "kind": "INTERFACE",
              "name": "Coupon"
            },
            "args": [],
            "isDeprecated": true
          },
          {
            "name": "coupons",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "Coupon"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "StripeSubscriptionPrecreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "firstPeriodEnd",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "firstPeriodStart",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "priceAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "trialEnd",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "UNION",
        "name": "StripeSubscriptionStopCancelError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "MainSubscriptionIsNotActiveError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "StripeSubscriptionStopCancelInput",
        "inputFields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "StripeSubscriptionStopCancelPayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "StripeSubscriptionStopCancelError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "subscriptionInfo",
            "type": {
              "kind": "OBJECT",
              "name": "SubscriptionInfo"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StudyDuration",
        "fields": [
          {
            "name": "cursor",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "data",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "PrimarySkillStudyDuration"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "date",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "month",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "year",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "StudyStats",
        "fields": [
          {
            "name": "from",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "studyDuration",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "StudyDuration"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "to",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "StudyStatsFrequency",
        "enumValues": [
          {
            "name": "MONTHLY",
            "isDeprecated": false
          },
          {
            "name": "WEEKLY",
            "isDeprecated": false
          },
          {
            "name": "YEARLY",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SubscriptionInfo",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canCancel",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canStopCancel",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "currentPeriodEnd",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "currentPeriodStart",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isSiblingDiscounted",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nextPaymentAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "nextPaymentDate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "provider",
            "type": {
              "kind": "ENUM",
              "name": "SubscriptionProvider"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "refundAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "ENUM",
              "name": "SubscriptionStatus"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "subscriptionEndDate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "type",
            "type": {
              "kind": "ENUM",
              "name": "SubscriptionType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SubscriptionIsMainSubscriptionError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SubscriptionProvider",
        "enumValues": [
          {
            "name": "APPLE",
            "isDeprecated": false
          },
          {
            "name": "GOOGLE",
            "isDeprecated": false
          },
          {
            "name": "WEB",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SubscriptionSchoolContent",
        "fields": [
          {
            "name": "accessControl",
            "type": {
              "kind": "OBJECT",
              "name": "SchoolContentAccessControl"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseSchoolContent"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SubscriptionStatus",
        "enumValues": [
          {
            "name": "ACTIVE",
            "isDeprecated": false
          },
          {
            "name": "CANCELED",
            "isDeprecated": false
          },
          {
            "name": "CANCELING",
            "isDeprecated": false
          },
          {
            "name": "PAST_DUE",
            "isDeprecated": false
          },
          {
            "name": "TRIALING",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "SubscriptionType",
        "enumValues": [
          {
            "name": "MONTHLY",
            "isDeprecated": false
          },
          {
            "name": "SUMMER_CAMPAIGN",
            "isDeprecated": false
          },
          {
            "name": "YEARLY",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Survey",
        "fields": [
          {
            "name": "description",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "surveyQuestions",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SurveyQuestion"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestion",
        "fields": [
          {
            "name": "displayOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "question",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "questionType",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "SurveyQuestionType"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "required",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "surveyQuestionChoices",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SurveyQuestionChoice"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "SurveyQuestionChoice",
        "fields": [
          {
            "name": "choiceText",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "displayOrder",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "SurveyQuestionType",
        "enumValues": [
          {
            "name": "MULTIPLE_CHOICES",
            "isDeprecated": false
          },
          {
            "name": "SINGLE_CHOICE",
            "isDeprecated": false
          },
          {
            "name": "TEXT",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SurveyResponseAnswerInput",
        "inputFields": [
          {
            "name": "choiceId",
            "type": {
              "kind": "SCALAR",
              "name": "ID"
            }
          },
          {
            "name": "questionId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "textAnswer",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "UNION",
        "name": "SurveyResponseCreateError",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "ValidationError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "SurveyResponseCreateInput",
        "inputFields": [
          {
            "name": "responseableInput",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "INPUT_OBJECT",
                "name": "ResponseableInput"
              }
            }
          },
          {
            "name": "surveyId",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          },
          {
            "name": "surveyResponseAnswers",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "INPUT_OBJECT",
                    "name": "SurveyResponseAnswerInput"
                  }
                }
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "SurveyResponseCreatePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "UNION",
                  "name": "SurveyResponseCreateError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TertiarySkill",
        "fields": [
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "proficiency",
            "type": {
              "kind": "SCALAR",
              "name": "Float"
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "skillSteps",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "SkillStep"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "ThinkingLevel",
        "enumValues": [
          {
            "name": "GRADE_1",
            "isDeprecated": false
          },
          {
            "name": "GRADE_10",
            "isDeprecated": false
          },
          {
            "name": "GRADE_11",
            "isDeprecated": false
          },
          {
            "name": "GRADE_12",
            "isDeprecated": false
          },
          {
            "name": "GRADE_2",
            "isDeprecated": false
          },
          {
            "name": "GRADE_3",
            "isDeprecated": false
          },
          {
            "name": "GRADE_4",
            "isDeprecated": false
          },
          {
            "name": "GRADE_5",
            "isDeprecated": false
          },
          {
            "name": "GRADE_6",
            "isDeprecated": false
          },
          {
            "name": "GRADE_7",
            "isDeprecated": false
          },
          {
            "name": "GRADE_8",
            "isDeprecated": false
          },
          {
            "name": "GRADE_9",
            "isDeprecated": false
          },
          {
            "name": "NONE",
            "isDeprecated": false
          },
          {
            "name": "PRE_GRADE_1",
            "isDeprecated": false
          },
          {
            "name": "PRE_GRADE_2",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "TokenInvalid",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TokenRefreshInput",
        "inputFields": [
          {
            "name": "fingerprint",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          },
          {
            "name": "refreshToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "TokenRefreshPayload",
        "fields": [
          {
            "name": "authentication",
            "type": {
              "kind": "OBJECT",
              "name": "AuthenticationPayload"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "TrialCoupon",
        "fields": [
          {
            "name": "endAt",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ISO8601Date"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "name",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Coupon"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "Tutorial",
        "fields": [
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TutorialKind"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "status",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TutorialStatus"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "step",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "TutorialCompleteInput",
        "inputFields": [
          {
            "name": "kind",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "TutorialKind"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "TutorialCompletePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "INTERFACE",
                  "name": "BaseError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "viewer",
            "type": {
              "kind": "OBJECT",
              "name": "User"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "TutorialKind",
        "enumValues": [
          {
            "name": "MEMBERSHIP_QUESTIONNAIRE",
            "isDeprecated": false
          },
          {
            "name": "ONBOARD_CHALLENGE_USER",
            "isDeprecated": false
          },
          {
            "name": "UNKNOWN",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "TutorialStatus",
        "enumValues": [
          {
            "name": "COMPLETED",
            "isDeprecated": false
          },
          {
            "name": "IN_PROGRESS",
            "isDeprecated": false
          },
          {
            "name": "NOT_STARTED",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UniqueValidation",
        "fields": [
          {
            "name": "_",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "UnknownPaymentMethod",
        "fields": [
          {
            "name": "displayName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "PaymentMethod"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UploadedFile",
        "fields": [
          {
            "name": "fileType",
            "type": {
              "kind": "ENUM",
              "name": "UploadedFileType"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "filename",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "size",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "url",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "UploadedFileType",
        "enumValues": [
          {
            "name": "IMAGE",
            "isDeprecated": false
          },
          {
            "name": "VIDEO",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "User",
        "fields": [
          {
            "name": "canCreateGuardian",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canCreatePlayer",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canDelete",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "canSwitchToWebPayment",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "challenges",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Challenge"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "curriculumLicensesConnection",
            "type": {
              "kind": "OBJECT",
              "name": "CurriculumLicenseConnection"
            },
            "args": [
              {
                "name": "after",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "before",
                "type": {
                  "kind": "SCALAR",
                  "name": "String"
                }
              },
              {
                "name": "first",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              },
              {
                "name": "last",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "defaultPaymentMethod",
            "type": {
              "kind": "INTERFACE",
              "name": "PaymentMethod"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "email",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "emailNotification",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "firstName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "fullName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "gotPaymentProblem",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "guardian",
            "type": {
              "kind": "OBJECT",
              "name": "Guardian"
            },
            "args": [
              {
                "name": "id",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "guardians",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Guardian"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasCurriculumLicense",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "hasSubscription",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "invoicesPagination",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "InvoicePagination"
              }
            },
            "args": [
              {
                "name": "page",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "1"
              },
              {
                "name": "perPage",
                "type": {
                  "kind": "SCALAR",
                  "name": "Int"
                },
                "defaultValue": "25"
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "isChallengeUserOnly",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Boolean"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "isFreeTrialUser",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "lastName",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "latestPaymentDate",
            "type": {
              "kind": "SCALAR",
              "name": "ISO8601Date"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "mainSubscriptionIsTrialing",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "notCompletedTutorials",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Tutorial"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "notSignedContracts",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "Contract"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "orderUid",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "ownPromotionCode",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "paymentType",
            "type": {
              "kind": "ENUM",
              "name": "UserPaymentType"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "players",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "OBJECT",
                    "name": "Player"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "schoolUsers",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "SchoolUser"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "userType",
            "type": {
              "kind": "ENUM",
              "name": "UserType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseUser"
          },
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "UserDoesNotHaveCurriculumLicenseError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "UserPaymentType",
        "enumValues": [
          {
            "name": "APPLE_IN_APP",
            "isDeprecated": false
          },
          {
            "name": "GOOGLE_IN_APP",
            "isDeprecated": false
          },
          {
            "name": "ORIGINAL_IN_WEB",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "UserType",
        "enumValues": [
          {
            "name": "DEBUG_TESTER",
            "isDeprecated": false
          },
          {
            "name": "DISTRIBUTOR_TESTER",
            "isDeprecated": false
          },
          {
            "name": "GENERAL_USER",
            "isDeprecated": false
          },
          {
            "name": "ORGANIZATION_ADMIN",
            "isDeprecated": false
          },
          {
            "name": "PRODUCT_TESTER",
            "isDeprecated": false
          },
          {
            "name": "SCHOOL_USER",
            "isDeprecated": false
          },
          {
            "name": "SYSTEM_ADMIN",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "ValidationError",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "validation",
            "type": {
              "kind": "UNION",
              "name": "ValidationType"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ValidationType",
        "possibleTypes": [
          {
            "kind": "OBJECT",
            "name": "FormatValidation"
          },
          {
            "kind": "OBJECT",
            "name": "LengthValidation"
          },
          {
            "kind": "OBJECT",
            "name": "UniqueValidation"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "VerificationCodeInvalid",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "ENUM",
        "name": "VerificationField",
        "enumValues": [
          {
            "name": "BIRTHDATE",
            "isDeprecated": false
          },
          {
            "name": "MEMBER_ID",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "ViewerDeleteInput",
        "inputFields": [
          {
            "name": "refreshToken",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "ViewerDeletePayload",
        "fields": [
          {
            "name": "errors",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "ValidationError"
                }
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "VirtualKoovContestTrack",
        "fields": [
          {
            "name": "played",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "rankingPercentage",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "score",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "OBJECT",
        "name": "VirtualKoovLessonGroup",
        "fields": [
          {
            "name": "allLessonTracksCompleted",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          },
          {
            "name": "id",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "ID"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "snap",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "OBJECT",
                "name": "UploadedFile"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "virtualKoovLessonTracks",
            "type": {
              "kind": "LIST",
              "ofType": {
                "kind": "NON_NULL",
                "ofType": {
                  "kind": "OBJECT",
                  "name": "VirtualKoovLessonTrack"
                }
              }
            },
            "args": [
              {
                "name": "playerId",
                "type": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "ID"
                  }
                }
              }
            ],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "Node"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "VirtualKoovLessonTrack",
        "fields": [
          {
            "name": "played",
            "type": {
              "kind": "SCALAR",
              "name": "Boolean"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "star",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "title",
            "type": {
              "kind": "SCALAR",
              "name": "String"
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "ENUM",
        "name": "WeekdayType",
        "enumValues": [
          {
            "name": "FRIDAY",
            "isDeprecated": false
          },
          {
            "name": "MONDAY",
            "isDeprecated": false
          },
          {
            "name": "SATURDAY",
            "isDeprecated": false
          },
          {
            "name": "SUNDAY",
            "isDeprecated": false
          },
          {
            "name": "THURSDAY",
            "isDeprecated": false
          },
          {
            "name": "TUESDAY",
            "isDeprecated": false
          },
          {
            "name": "WEDNESDAY",
            "isDeprecated": false
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "WeeklyLearningTimeSetting",
        "fields": [
          {
            "name": "learningTime",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "weekday",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WeekdayType"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      },
      {
        "kind": "INPUT_OBJECT",
        "name": "WeeklyLearningTimeSettingInput",
        "inputFields": [
          {
            "name": "learningTime",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            }
          },
          {
            "name": "weekday",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "ENUM",
                "name": "WeekdayType"
              }
            }
          }
        ],
        "isOneOf": false
      },
      {
        "kind": "OBJECT",
        "name": "WrongEmailOrPassword",
        "fields": [
          {
            "name": "field",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "LIST",
                "ofType": {
                  "kind": "NON_NULL",
                  "ofType": {
                    "kind": "SCALAR",
                    "name": "String"
                  }
                }
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "message",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "String"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": [
          {
            "kind": "INTERFACE",
            "name": "BaseError"
          }
        ]
      },
      {
        "kind": "OBJECT",
        "name": "YearlyPriceInfo",
        "fields": [
          {
            "name": "amount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "campaignAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "campaignDifferentAmount",
            "type": {
              "kind": "SCALAR",
              "name": "Int"
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "differentAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          },
          {
            "name": "monthlyAmount",
            "type": {
              "kind": "NON_NULL",
              "ofType": {
                "kind": "SCALAR",
                "name": "Int"
              }
            },
            "args": [],
            "isDeprecated": false
          }
        ],
        "interfaces": []
      }
    ],
    "directives": []
  }
} as const;

export { introspection };